<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="min(960px, calc(100vw - 24px))">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="readonly && form.routingId" class="title-actions">
        <el-button v-if="isAuth('base:routing:update')" type="primary" size="small" @click="readonly = false">修改</el-button>
        <el-button v-if="isAuth('base:routing:delete')" type="primary" size="small" @click="remove">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" class="routing-form" :model="form" :rules="readonly ? {} : rules" :validate-on-rule-change="false" label-width="90px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="工艺编码" prop="routingCode">
            <el-input v-model="form.routingCode" :disabled="readonly" placeholder="工艺编码" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工艺名称" prop="routingName">
            <el-input v-model="form.routingName" :disabled="readonly" placeholder="工艺名称" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="启用状态" prop="isenabled">
            <el-radio-group v-model="form.isenabled" :disabled="readonly">
              <el-radio label="0">启用</el-radio>
              <el-radio label="1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" :disabled="readonly" type="textarea" :rows="2" placeholder="备注" />
      </el-form-item>
      <el-form-item label="工序列表" prop="lines">
        <div style="margin-bottom: 10px;">
          <el-button v-if="!readonly" type="primary" size="small" @click="openSelectProcess">选择工序</el-button>
        </div>
        <el-table :data="form.lines" border style="width: 100%;" :header-cell-style="headStyle">
          <el-table-column type="index" width="50" label="序号" align="center" />
          <el-table-column prop="processCode" label="工序编码" header-align="center" align="left" show-overflow-tooltip />
          <el-table-column prop="processName" label="工序名称" header-align="center" align="left" show-overflow-tooltip />
          <el-table-column prop="processNumber" label="人数" header-align="center" align="right" width="90">
            <template slot-scope="scope">
              <el-input v-if="!readonly" v-model="scope.row.processNumber" @blur="onDecimalBlur(scope.row, 'processNumber')" />
              <span v-else>{{ scope.row.processNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="processBeat" label="节拍" header-align="center" align="right" width="90">
            <template slot-scope="scope">
              <el-input v-if="!readonly" v-model="scope.row.processBeat" @blur="onDecimalBlur(scope.row, 'processBeat')" />
              <span v-else>{{ scope.row.processBeat }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="isReport" label="允许报工" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-radio-group v-if="!readonly" v-model="scope.row.isReport">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
              <span v-else>{{ scope.row.isReport === '1' ? '否' : '是' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" align="center" width="140">
            <template slot-scope="scope">
              <el-input-number v-if="!readonly" v-model="scope.row.sort" :min="0" :precision="0" controls-position="right" style="width: 110px" />
              <span v-else>{{ scope.row.sort }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="form.lines.splice(scope.$index, 1)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save()">确定</el-button>
    </span>

    <el-dialog title="选择工序" :visible.sync="selectVisible" width="min(800px, calc(100vw - 24px))" append-to-body>
      <el-form :inline="true" :model="processQuery" @keyup.enter.native="processPage = 1; loadProcesses()">
        <el-form-item label="工序编码">
          <el-input v-model="processQuery.processCode" placeholder="工序编码" size="small" style="width:150px" clearable />
        </el-form-item>
        <el-form-item label="工序名称">
          <el-input v-model="processQuery.processName" placeholder="工序名称" size="small" style="width:150px" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="processPage = 1; loadProcesses()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="processList" border height="320" v-loading="processLoading" @selection-change="val => processSelection = val" :header-cell-style="headStyle">
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column type="index" width="60" align="center" label="序号" />
        <el-table-column prop="processCode" header-align="center" label="工序编码" show-overflow-tooltip />
        <el-table-column prop="processName" header-align="center" label="工序名称" show-overflow-tooltip />
        <el-table-column prop="processNumber" header-align="center" label="人数" align="left" width="90" />
        <el-table-column prop="processBeat" header-align="center" label="节拍" align="left" width="90" />
      </el-table>
      <el-pagination @size-change="val => { processSize = val; processPage = 1; loadProcesses() }"
        @current-change="val => { processPage = val; loadProcesses() }"
        :current-page="processPage" :page-sizes="[20, 50, 100]" :page-size="processSize" :total="processTotal"
        layout="total, sizes, prev, pager, next, jumper" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSelect">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      visible: false, readonly: false, form: { lines: [] }, permCodes: [],
      selectVisible: false, processQuery: { processCode: '', processName: '' }, processList: [], processSelection: [],
      processPage: 1, processSize: 20, processTotal: 0, processLoading: false,
      headStyle: { background: '#f5f7fa', color: '#606266' },
      rules: {
        routingCode: [{ required: true, message: '工艺编码不能为空', trigger: 'blur' }],
        routingName: [{ required: true, message: '工艺名称不能为空', trigger: 'blur' }],
        isenabled: [{ required: true, message: '启用状态不能为空', trigger: 'change' }],
        lines: [{ required: true, message: '请至少选择一个工序', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看工艺'
      return this.form.routingId ? '修改工艺' : '新增工艺'
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(id, readonly) {
      this.readonly = !!readonly
      this.form = { isenabled: '0', lines: [], routingVersion: '', version: 0 }
      this.visible = true
      this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      if (id) this.fetchDetail(id)
    },
    fetchDetail(id) {
      request.get('/base/routing/info/' + id).then(res => {
        const row = res.data || {}
        row.lines = (row.lines || []).map(item => ({
          routingProcessId: item.routingProcessId,
          processId: item.processId,
          processCode: item.processCode,
          processName: item.processName,
          processNumber: item.processNumber != null ? String(item.processNumber) : '',
          processBeat: item.processBeat != null ? String(item.processBeat) : '',
          isReport: item.isReport || '0',
          sort: item.sort || 0,
          remark: item.remark
        }))
        this.form = row
      }).catch(() => {})
    },
    handleConcurrentConflict(msg) {
      const text = msg || '操作失败'
      if (text.indexOf('数据已被其他用户更新') === -1 || !this.form.routingId) return
      this.$confirm('当前数据已被其他用户更新，是否重新加载最新数据？', '提示', {
        confirmButtonText: '重新加载',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => { this.fetchDetail(this.form.routingId) }).catch(() => {})
    },
    onDecimalBlur(row, field) {
      if (!row[field]) return
      if (!/^(\d+)(\.\d{1,2})?$/.test(row[field])) {
        this.$message.error('请输入数字，最多保留两位小数')
        row[field] = ''
      }
    },
    openSelectProcess() {
      this.processSelection = []
      this.processList = []
      this.selectVisible = true
      this.processPage = 1
      this.loadProcesses()
    },
    loadProcesses() {
      this.processLoading = true
      request.post('/base/process/list', {
        currentPage: this.processPage, pageSize: this.processSize,
        processCode: this.processQuery.processCode, processName: this.processQuery.processName, isenabled: '0'
      }).then(res => {
        const body = res.data || {}
        this.processList = body.list || []
        this.processTotal = body.totalCount || 0
      }).finally(() => { this.processLoading = false })
    },
    confirmSelect() {
      const exists = (this.form.lines || []).map(item => item.processId)
      ;(this.processSelection || []).forEach(row => {
        if (exists.indexOf(row.processId) === -1) {
          this.form.lines.push({
            processId: row.processId,
            processCode: row.processCode,
            processName: row.processName,
            processNumber: row.processNumber != null ? String(row.processNumber) : '',
            processBeat: row.processBeat != null ? String(row.processBeat) : '',
            isReport: '0',
            sort: this.form.lines.length + 1
          })
          exists.push(row.processId)
        }
      })
      this.selectVisible = false
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.form.lines || !this.form.lines.length) {
          this.$message.error('请至少选择一个工序')
          return
        }
        const payload = Object.assign({}, this.form, { processList: this.form.lines })
        request.post('/base/routing/' + (this.form.routingId ? 'update' : 'save'), payload).then(() => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(err => { this.handleConcurrentConflict(err && err.message) })
      })
    },
    remove() {
      this.$confirm('确定删除该工艺？', '提示', { type: 'warning' }).then(() => {
        request.post('/base/routing/delete', [this.form.routingId]).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
@media (max-width: 800px) {
  .routing-form >>> .el-col-12 { width: 100%; }
}
</style>
